import { api } from './NetworkUtility';
import { logError } from './ErrorService';

export const getCheckImage = (companyNumber, paymentUUID, callbackHandler) => {

    const url = `/companies/${companyNumber}/documents/getCheckImage/${paymentUUID}`;

    api.get(url)
        .then(response => {
            callbackHandler(response)
        })
        .catch(error => {
            callbackHandler(error.response);
        });
}